import * as React from "react";
import * as _ from "lodash";
import {
  Badge,
  Heading,
  Text,
  Box,
  Grid,
  VStack,
  GridItem,
  Button,
  ScaleFade,
} from "@chakra-ui/react";
import { DateTile } from "./DateTile";
import { bookableDates } from "./data";

const allowedSelectionPerWeek = 3;

type FormState = {
  hasSelectedDates: boolean;
};

export function WeekdaySelector(): React.ReactElement {
  const [formState, setFormState] = React.useState<FormState>({
    hasSelectedDates: false,
  });

  const [selectedDates, setSelectedDates] = React.useState<Array<Date>>([]);

  const handleDatesSelectedClick = () => {
    setFormState((formState) => ({
      ...formState,
      hasSelectedDates: true,
    }));
  };

  const handleDayClick = (date: Date) => () => {
    setSelectedDates((currentDays) => {
      if (
        _.size(currentDays) < allowedSelectionPerWeek &&
        !_.includes(currentDays, date)
      ) {
        return _.sortBy(_.concat(currentDays, date));
      } else {
        return _.without(currentDays, date);
      }
    });
  };
  return (
    <VStack spacing={8}>
      <Box>
        <VStack spacing={4}>
          <Heading size="lg">
            Select your days in the office for next week below
          </Heading>
          <Text>
            <Badge fontSize="lg" mr="2">
              {_.size(selectedDates)} / {allowedSelectionPerWeek}
            </Badge>
            days selected
          </Text>
          <Grid
            templateColumns="repeat(7, 1fr)"
            templateRows="auto"
            rowGap={4}
            columnGap={2}
          >
            {bookableDates.map((bookableDate) => (
              <GridItem key={bookableDate.date.toString()}>
                <DateTile
                  date={bookableDate.date}
                  onClick={handleDayClick(bookableDate.date)}
                  disabled={
                    !_.includes(selectedDates, bookableDate.date) &&
                    _.size(selectedDates) === allowedSelectionPerWeek
                  }
                  teammates={bookableDate.teammates}
                  activities={bookableDate.activities}
                  selected={_.includes(selectedDates, bookableDate.date)}
                />
              </GridItem>
            ))}
          </Grid>
          <Button
            variant="solid"
            onClick={handleDatesSelectedClick}
            disabled={formState.hasSelectedDates}
          >
            Next
          </Button>
        </VStack>
      </Box>
      <ScaleFade in={formState.hasSelectedDates} initialScale={0.75}>
        <Box fontSize="xl">
          <Text size="lg" marginBottom="2">
            Your in-office preferences have been submitted.
          </Text>
          <Text>
            Thank you for using{" "}
            <Text as="span" color="teal">
              Flock
            </Text>
            !
          </Text>
        </Box>
      </ScaleFade>
    </VStack>
  );
}
